import { CumulativeBoosterID } from "../cumulative_boosters/cumulative_booster_id.js";
import { CumulativeBoosterService } from "../cumulative_boosters/cumulative_booster_service.js";
import { ServerClock } from "../offline/server_clock.js";
import { StatisticsStorage } from "../storage/statistics_storage.js";

const MINUTE_MS = 60_000;

export const BALANCE_SNAPSHOT_KEYS = [
  "balance_coins",
  "balance_hearts",
  "balance_big_balls",
  "balance_infinite_balls",
  "balance_multi_balls",
  "balance_fireworks",
  "balance_rockets",
  "balance_mines",
  "balance_infinite_hearts_min",
  "balance_no_ads_min",
] as const;

export type BalanceSnapshot = Record<( typeof BALANCE_SNAPSHOT_KEYS )[number], number>;

export function minutesLeft( until_ms: number, now_ms: number ): number
{
  return Number.isFinite( until_ms ) && until_ms > now_ms ? Math.ceil( ( until_ms - now_ms ) / MINUTE_MS ) : 0;
}

export function balanceSnapshot(): BalanceSnapshot
{
  const stats = StatisticsStorage.load();
  const inventory = CumulativeBoosterService.inventory;
  const now = ServerClock.nowMs();
  return {
    balance_coins: stats.coins,
    balance_hearts: stats.hearts,
    balance_big_balls: inventory.getCount( CumulativeBoosterID.BigBall ),
    balance_infinite_balls: inventory.getCount( CumulativeBoosterID.InfiniteBalls ),
    balance_multi_balls: inventory.getCount( CumulativeBoosterID.Multiball ),
    balance_fireworks: inventory.getCount( CumulativeBoosterID.Fireworks ),
    balance_rockets: inventory.getCount( CumulativeBoosterID.Rocket ),
    balance_mines: inventory.getCount( CumulativeBoosterID.Mine ),
    balance_infinite_hearts_min: minutesLeft( stats.infinite_hearts_until, now ),
    balance_no_ads_min: minutesLeft( stats.no_ads_until, now ),
  };
}
